import {
  AgentIcon,
  Bubble,
  BubbleMessage,
  BubbleName,
  BubbleTime,
  Row,
} from "./styles";

import { ChatMessage } from "interfaces/Chat";
import React from "react";
import moment from "moment";

const AgentBubble: React.FC<ChatMessage> = ({ message, user, date }) => {
  const procTime = () => {
    if (new Date().getDay() !== new Date(date).getDay()) {
      return moment(new Date(date)).format("DD/MM HH:mm");
    }
    return moment(new Date(date)).format("HH:mm");
  };
  return (
    <Bubble>
      <Row>
        <AgentIcon />
        <BubbleName>{user.name}</BubbleName>
      </Row>
      <BubbleMessage>{message}</BubbleMessage>
      <Row style={{ justifyContent: "flex-end" }}>
        <BubbleTime>{procTime()}</BubbleTime>
      </Row>
    </Bubble>
  );
};

export default AgentBubble;
